// swiper js slider starts
var listArray = ["01", "02", "03"];
var swiper = new Swiper(".mySwiper", {
    loop: false,
    effect: "cards",
    grabCursor: true,
    autoplay: {
        delay: 3000,
      disableOnInteraction: false,
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: "true",
        type: "bullets",
        renderBullet: function (index, className) {
            return (
                '<span class="' +
                className +
                '">' +
                "<em class='text_md comfortaaRegular'>" +
                listArray[index] +
                "</em>" +
                "<i></i>" +
                "<b></b>" +
                "</span>"
            );
        },
    },
});

// swiper js slider ends

// Popup in Ingredients section starts
function openPopup(el) {
    $(".section-header.shopify-section-group-header-group").hide();
    $(".popup").hide();
    $("#" + el).fadeIn(200);
  if($(".features_slider").hasClass('slick-initialized')) {
    $(".features_slider").slick("refresh");
  }
}

function closePopup() {
    $(".section-header.shopify-section-group-header-group").show();
    $(".popup").fadeOut(300);
}

// Popup in Ingredients section ends

$(document).ready(function () {

    $('.moreless-button').click(function() {
      $('.moretext').slideToggle();
      if ($('.moreless-button').text() == "View All") {
        $(this).text("View less")
      } else {
        $(this).text("View All")
      }
    });
    
    //Sticky menu functionality starts here

    //nav menu highlight starts
    $(window).on("scroll", function () {
        var scrollPosition = $(this).scrollTop();
        var threshold = 100; // Adjust this value as needed

        // Iterate through each section to find the one in view
        $("section").each(function () {
            var topOffset = $(this).offset().top;

            var distance = topOffset - scrollPosition;

            // Check if the section is in the viewport
            if (distance < threshold) {
                var sectionId = $(this).attr("id");
                // Remove existing highlight class and add it to the corresponding menu item
                $(".nav-li").removeClass("active");
                $('.nav-li[data-menu="' + sectionId + '"]').addClass("active");
            }
            
            
        });
        
    });
    
    //nav menu highlight ends

    //onclick of nav menu scrolls to its section starts
    $(".nav-section .nav-li").on("click", function () {
        var getParent = $(this).parents(".nav-section");
        getParent.find(".nav-li").removeClass("active");
        $(this).addClass("active");
        var nav_id = $(this).attr("data-menu");

        const desiredDistance = 84;
        // Get the current top position of the section
        const sectionTop = document
            .getElementById(nav_id)
            .getBoundingClientRect().top;

        // Calculate the scroll amount needed to reach the desired distance
        const scrollAmount = sectionTop - desiredDistance;

        // Smoothly scroll the window to the calculated position
        window.scrollTo({
            top: window.pageYOffset + scrollAmount,
            behavior: "smooth",
        });
    });
    //onclick of nav menu scrolls to its section starts

    //Sticky menu functionality ends here

    //popup slider starts
    $(".popup_slider").slick({
        dots: false,
        autoplay: false,
        arrows: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        lazyLoad: "progressive",
        autoplaySpeed: 2000,
        centerMode: true,
        prevArrow:
            "<img class='slick-prev img-responsive' src='https://cdn.shopify.com/s/files/1/0775/1060/7155/t/1/assets/Group5148.svg'>",
        nextArrow:
            "<img class='next slick-next img-responsive' src='https://cdn.shopify.com/s/files/1/0775/1060/7155/t/1/assets/Group5147.svg'>",
        
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                },
            },
            {
                breakpoint: 1600,
                settings: {
                  arrows: true
                },
            },
        ],
    });

    // Redirecting the ingredient card to its info inside popup slider starts
    $("[data-slide]").click(function (e) {
        e.preventDefault();
        var slideno = $(this).data("slide");
        $(".popup_slider").slick("slickGoTo", slideno - 1);
    });
    // Redirecting the ingredient card to its info inside popup slider ends

    // scroll section starts
    $(".scrollTo").click(function () {
        $("html, body").animate(
            {
                scrollTop: $($(this).attr("href")).offset().top,
            },
            500
        );
        return false;
    });

    // scroll section ends

    //popup slider ends

    //Slider in ingredient slider starts

    var $slider = $(".ingredient-sldier");
    var $progressBar = $(".progress");
    var $progressBarLabel = $(".progress_bar");
    $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
    var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
    
    $progressBar
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );
    
    $progressBarLabel.text( calc + '% completed' );
  });

    $slider.slick({
        dots: false,
        arrows: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow:
            "<img class='slick-prev img-responsive' src='https://cdn.shopify.com/s/files/1/0775/1060/7155/t/1/assets/prev.svg'>",
        nextArrow:
            "<img class='slick-next img-responsive' src='https://cdn.shopify.com/s/files/1/0775/1060/7155/t/1/assets/next.svg'>",
        
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    variableWidth: true,
                    centerMode: false,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    variableWidth: true,
                },
            },
        ],
    });

    //Slider in ingredient slider ends

    // Tab functionality in Additional Information starts here

    $(".tab_new_popular .tab_li").on("click", function () {
        var getParent = $(this).parents(".tab_new_popular");
        getParent.find(".tab_li").removeClass("active");
        $(this).addClass("active");
        var tab_id = $(this).attr("data-tab");
        getParent.find(".tab-content").removeClass("current");
        $("#" + tab_id).addClass("current");
    });
    // Tab functionality in Additional Information end here

    // Accordion functionality in Additional Information starts here
    $(".accordion_section .accordion_title").on(
        "click",
        function () {
            //console.log("sdfd");
            //if the open accordion is clicked
            if ($(this).hasClass("active")) {
                //closing the current opened accordian
                $(this).removeClass("active");
                $(this)
                    .parents(".accordion_section")
                    .find(".accordion_content")
                    .slideUp(200);
            } else {
                //closing all the accordians
                $(this)
                    .parents(".accordion_area")
                    .find(".accordion_title")
                    .removeClass("active");
                $(this)
                    .parents(".accordion_area")
                    .find(".accordion_content")
                    .slideUp(200);

                //opening the clicked accordian
                $(this).addClass("active");
                $(this)
                    .parents(".accordion_section")
                    .find(".accordion_content")
                    .slideDown(200);
            }
        }
    );
    // Accordion functionality in Additional Information ends here

    // Testimonial section slider scripts starts here
    var popularSlider = $(".popular_slider").slick({
        dots: true,
        arrows: true,
        autoplay: false,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        pauseOnHover: false,
        autoplaySpeed: 3000,
        prevArrow:
            "<img class='a-left control-c prev slick-prev img-responsive' src='https://cdn.shopify.com/s/files/1/0775/1060/7155/t/1/assets/prev.svg'>",
        nextArrow:
            "<img class='a-right control-c next slick-next img-responsive' src='https://cdn.shopify.com/s/files/1/0775/1060/7155/t/1/assets/next.svg'>",
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    autoplay: true,
                    slidesToShow: 1,
                    speed: 1000,
                    // centerMode: true,
                    variableWidth: true,
                },
            },
        ],
    });

    $("#best_sellers .tabs .tab_ul .tab_li").click(function () {
        popularSlider.slick("refresh");
    });
    // Testimonial section slider scripts ends here

    // Testimonial section slider scripts starts here
    var customerLeftSlider = $(".left_slider").not('.slick-initialized').slick({
        dots: false,
        arrows: false,
        infinite: true,
        // autoplay: true,
        // speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: ".slider_two, .slider_one",
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    arrows: true,
                    prevArrow:
                        "<img class='a-left control-c prev slick-prev img-responsive' src='https://cdn.shopify.com/s/files/1/0775/1060/7155/t/1/assets/prev.svg'>",
                    nextArrow:
                        "<img class='a-right control-c next slick-next img-responsive' src='https://cdn.shopify.com/s/files/1/0775/1060/7155/t/1/assets/next.svg'>",
                },
            },
            // {
            // 	breakpoint: 767,
            // 	settings: {
            // 		arrows: true,
            // 	},
            // },
        ],
    });
    var customerRightFirstSlider = $(".slider_one").not('.slick-initialized').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        // speed: 300,
        // autoplay: true,
        lazyLoad: "ondemand",
        arrows: false,
        dots: false,
        variableWidth: true,
        asNavFor: ".slider_two, .left_slider",
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    variableWidth: true,
                    prevArrow:
                        "<img class='a-left control-c prev slick-prev img-responsive' src='https://cdn.shopify.com/s/files/1/0775/1060/7155/t/1/assets/prev.svg'>",
                    nextArrow:
                        "<img class='a-right control-c next slick-next img-responsive' src='https://cdn.shopify.com/s/files/1/0775/1060/7155/t/1/assets/next.svg'>",
                },
            },
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                },
            },
        ],
    });
    var customerRightSecondSlider = $(".slider_two").not('.slick-initialized').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        // speed: 300,
        // autoplay: true,
        variableWidth: true,
        lazyLoad: "ondemand",
        infinite: true,
        initialSlide: 2,
        asNavFor: ".slider_one, .left_slider",
        dots: false,
        arrows: true,
        prevArrow:
            "<img class='a-left control-c prev slick-prev img-responsive' src='https://cdn.shopify.com/s/files/1/0775/1060/7155/t/1/assets/prev.svg'>",
        nextArrow:
            "<img class='a-right control-c next slick-next img-responsive' src='https://cdn.shopify.com/s/files/1/0775/1060/7155/t/1/assets/next.svg'>",
        responsive: [
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    variableWidth: false,
                },
            },
        ],
    });
    $("#testimonial .tabs .tab_ul .tab_li").click(function () {
        customerLeftSlider.slick("refresh");
        customerRightFirstSlider.slick("refresh");
        customerRightSecondSlider.slick("refresh");
    });
    // Testimonial section slider scripts ends here
});
var winW = $(window).outerWidth();
if (winW < 767)
{
    $(".features_slider").not('.slick-initialized').slick({
        dots: true,
        arrows: false,
        centerMode: false,
        speed: 100,
        autoplay: true,
        autoplaySpeed: 1500,
        slidesToShow: 2,
        slidesToScroll: 1,
    });
}

var winH = $(window).outerHeight();
var isFirst = true;
$(window).on("scroll", function (e) {
  if($("#product_page").length) {
  var scrollTopPos = $(window).scrollTop();
  var bannerOffTop = $("#ingredients_section").offset().top - 460;
  if (bannerOffTop + winH <= scrollTopPos) {
    //console.log("product_tabs - rady" + bannerOffTop);
    var $slider = $(".product-recommendations");

        $(".product-recommendations").not('.slick-initialized').slick({
          dots: false,
          arrows: true,
          autoplay: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          speed: 1000,
          autoplaySpeed: 3000,
          swipeToSlide: true,
          prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0775/1060/7155/files/prev.svg" class="slick-prev img-responsive">',
          nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0775/1060/7155/files/next.svg" class="slick-next img-responsive">',
          responsive: [{
                  breakpoint: 1199,
                  settings: {
                      slidesToShow: 3,
                      dots: false,
                      arrows: false,
                  },
              },
              {
                  breakpoint: 991,
                  settings: {
                      dots: false,
                      arrows: false,
                      slidesToShow: 2,
                      variableWidth: false
                  },
              },
              {
                  breakpoint: 767,
                  settings: {
                      dots: false,
                      arrows: false,
                    slidesToShow: 1,
                    centerMode: true,
                      variableWidth: false
                  },
              },
          ],
        });
        
  }
    if(isFirst){
    if($(".product-recommendations").length) {
      //alert("Recommendations is ready");
      $(function() {
        
        function renderCartNotificationProduct(key, title, image, variantTitle) {
        	return `<div id="shopify-section-cart-notification-product" class="shopify-section">
      		<div id="cart-notification-product-${key}" class="cart-item">
                <div class="cart-notification-product__image global-media-settings">
      			<img src="${image}" alt="Hard Rock" width="70" height="70" loading="lazy"> </div>
                <div>
                  <h3 class="cart-notification-product__name h4">${title}</h3>
      			${variantTitle ? `<dl>
                    <div class="product-option">
                        <!--<dt>Nicotine Strength: </dt>-->
      				  <dd>${variantTitle}</dd>              
                    </div>
                    </dl>`: ``
                  }
                </div> 
             </div>
          </div>`
        }
        
        function renderCartBubble(cartItemCount) {
        	return `<div id="shopify-section-cart-icon-bubble" class="shopify-section">
             <svg id="Icon_feather-shopping-cart" data-name="Icon feather-shopping-cart" xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42"> <g id="Group_148482" data-name="Group 148482" transform="translate(-1325 -45)"> <circle id="Ellipse_517" data-name="Ellipse 517" cx="21" cy="21" r="21" transform="translate(1325 45)" fill="#ffdf91"/> <path id="Path_1" data-name="Path 1" d="M3.468,5.087V2.051A1.552,1.552,0,0,1,5.019.5H9.943a1.552,1.552,0,0,1,1.551,1.551V5.9A1.552,1.552,0,0,1,9.943,7.448H2.051A1.551,1.551,0,0,0,.5,9v7.824a1.552,1.552,0,0,0,1.551,1.551H12.709a1.552,1.552,0,0,0,1.551-1.551V7.448" transform="translate(1338.599 56.238)" fill="none" stroke="#1c1c1a" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1.2"/> </g> </svg>
      		<div class="cart-count-bubble"><span aria-hidden="true">${cartItemCount}</span><span class="visually-hidden"> items</span>\n  </div>
          </div>
      	`
        }
        
        function getCart(callback) {
          $.ajax({
            type: 'GET',
            url: '/cart.js',
            dataType: 'json', 
            success: function (data) {
            	callback(data)
            }
          });
        }
        
        $('.cart_btn').on('click', function(e){
          e.preventDefault();
          var cartNotification = new CartNotification();
          cartNotification.setActiveElement(document.activeElement)
          //console.log("Add to cart")
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              items: [{
                quantity: parseInt($(this).parents(".card-information").find('.quantity__input').val()),
              //id: parseInt($(this).parents('.card-information').find('.product-form__input input[type=radio]:checked').attr('data-variant'))
                id: parseInt($(this).parents('.card-information').find('.product-form__input select option:selected').attr('data-variant'))
              }]
            },
            dataType: 'json', 
            success: function (data) {
              //console.log('data', data.items[0].options_with_values)
              
              var items = data.items;
              if (items.length) {
                var key = items[0].key
                var image = items[0].image
                var title = items[0].product_title
                var variantTitle = items[0].variant_title
                
                getCart((cartData)=>{
                  cartNotification.renderContents({
                    ...items[0],
                    key: key,
                    sections: {
                        "cart-notification-product": renderCartNotificationProduct(key, title, image, variantTitle),
                        "cart-notification-button": `<div id="shopify-section-cart-notification-button" class="shopify-section">View Cart (${cartData.item_count})</div>`,
                        "cart-icon-bubble": renderCartBubble(cartData.item_count)
                    }
                  })
                })
              }
            } 
          });
        })
      })
      isFirst=false;  
    }
    }
    
  }
});